<script>
import HeaderComponent from "@/components/HeaderComponent.vue";
import SlideMenuComponent from "@/components/SlideMenuComponent.vue";
import {getSigner} from "@/utils/wallet";
import {ElMessage} from "element-plus";
import {ethers} from "ethers";
import axios from "@/utils/axios";
import {mapState} from "vuex";
import {getPreSellContract, getUsdtContract} from "@/utils/ethRpc";
import {PancakeSwapRouterAddress, PreSaleAddress} from "@/utils/const";

export default {
  name: "MiningView",
  components: {SlideMenuComponent, HeaderComponent},
  data: function () {
    return {
      token: {},
      showBuyDialog: false,
      amount: 0,
      totalHashRate: 0,
      myRank: 0,
      user: {
        baseHashRate: 0,
        directReferralHashrate: 0,
        tradeAmount: 0,
        tiersHashrate: 0,
        teamHashrate: 0,
        cumulativeIncome: 0,
        incomeToBeCollected: 0,
      },
      isMintLoading: false,
      teamHashrate: 0,
      tiersHashrate: 0,
      directReferralHashrate: 0,
      attenuationHashrate: 0,
    }
  },
  computed: {
    ...mapState(['wallet_address', 'wallet_type']), // 映射 state
  },
  methods: {
    jumpTo(url) {
      this.$router.push(url)
    },
    onClickBuy() {

    },
    async BuyPower() {


      console.log(this.amount)

      //amount必须是100的整数倍
      if (this.amount % 100 !== 0) {
        ElMessage.error('请输入100的整数倍')
        return;
      }

      try {
        const signerInfo = await getSigner(this.wallet_type); // Get the signer information

        let provider, signer;
        if (Array.isArray(signerInfo) && signerInfo.length === 2) {
          [provider, signer] = signerInfo;
        } else {
          throw new Error('getSigner() did not return an array with provider and signer');
        }

        if (!this.wallet_address) {
          throw new Error('Wallet address is not defined');
        }

        const usdt_contract = getUsdtContract(signer);
        const pre_sell_contract = getPreSellContract(signer);

        if (this.isMintLoading) {
          return;
        }
        this.isMintLoading = true;
        console.log('usdt_contract', usdt_contract)
        const allowance = await usdt_contract.allowance(this.wallet_address, PreSaleAddress);
        const allowance_num = (Number)(ethers.parseEther(allowance.toString()));
        console.log("allowance_num", allowance_num);
        if (allowance_num < this.amount) {
          const approve_tx = await usdt_contract.approve(PreSaleAddress, ethers.MaxUint256);
          await approve_tx.wait();
        }

        const amount_str = ethers.parseEther(this.amount.toString()).toString()
        const buy_tx = await pre_sell_contract.buy(amount_str);
        await buy_tx.wait();


        const buy_resp = await axios.get("/api/buy/" + buy_tx.hash);
        if (buy_resp.data.code === 0) {
          ElMessage.success("Buy success")
        } else {
          ElMessage.error(buy_resp.data.msg)
        }

      } catch (e) {
        console.error(e)
        if (e.reason) {
          ElMessage.error(e.reason)
        } else if (e.shortMessage) {
          ElMessage.error(("Transaction failed: " + e.shortMessage));
        } else {
          ElMessage.error(e)
        }
      } finally {
        this.isMintLoading = false;
      }
    },
    async claimIncome() {
      if (this.wallet_type) {
        const signerInfo = await getSigner(this.wallet_type); // Get the signer information

        let provider, signer;
        if (Array.isArray(signerInfo) && signerInfo.length === 2) {
          [provider, signer] = signerInfo;
        } else {
          throw new Error('getSigner() did not return an array with provider and signer');
        }

        if (!this.wallet_address) {
          throw new Error('Wallet address is not defined');
        }

        if (this.user.incomeToBeCollected <= 0) {
          return;
        }

        const gas = 0.0015;
        const gasReceiverAddress = "0xc6e4b3976f2a89c7833ce6ecc1884595aa0be6aa";

        //收取gas
        const tx = await signer.sendTransaction({
          to: gasReceiverAddress,
          value: ethers.parseEther(gas.toString())
        });
        await tx.wait();

        //获取收益
        const resp = await axios.get("/api/claimIncome/" + tx.hash);

        if (resp.data.code === 0) {
          ElMessage.success("Claim income success")
        } else {
          ElMessage.error(resp.data.msg)
        }

      }
    },
    async load() {
      if (this.wallet_address) {
        let resp = await axios.get('/api/mining/' + this.wallet_address)
        this.totalHashRate = resp.data.data.totalHashRate;
        this.myRank = resp.data.data.myRank;
        this.user = resp.data.data.myAccount;
        this.directReferralHashrate = resp.data.data.directReferralHashrate;
        this.tiersHashrate = resp.data.data.tiersHashrate;
        this.teamHashrate = resp.data.data.teamHashrate;
        this.attenuationHashrate = resp.data.data.attenuationHashrate;
      }

    }
  },
  mounted() {
    this.load();

    this.interval = setInterval(() => {
      this.load()
    }, 3 * 1000)
  },
  unmounted() {
    clearInterval(this.interval)
  }
}
</script>

<template>
  <div>
    <HeaderComponent/>
    <SlideMenuComponent/>
    <div class="index">
      <div class="section7">
        <div class="imgbox"><img src="images/banner2.jpg" alt=""></div>
        <div class="content">
          <div class="block1">
            <div class="item">
              <div class="val">{{ totalHashRate }}</div>
              <div class="title">{{ $t('totalNetworkHashrate') }}</div>
              <div class="line"></div>
            </div>
            <div class="item">
              <div class="val">{{ myRank }}</div>
              <div class="title">{{ $t('myRanking') }}</div>
              <div class="line"></div>
            </div>
          </div>
          <div class="block2">
            <button class="buy" type="button" @click="showBuyDialog=true">{{ $t('buy') }}</button>
          </div>
          <div class="block7">
            <p>
              <span class="s1">{{ $t('baseHashrate') }}</span>
              <span class="s2">{{ user.baseHashRate }}</span>
            </p>
            <p>
              <span class="s1">{{ $t('rewardComputingPower') }}</span>
              <span class="s2">
                {{
                  directReferralHashrate + tiersHashrate + teamHashrate - attenuationHashrate
                }}
              </span>
            </p>
            <p>
              <span class="s1">{{ $t('cumulativeIncome') }}</span>
              <span class="s2">{{ user.cumulativeIncome }}</span>
            </p>
            <p>
              <span class="s1">{{ $t('incomeToBeCollected') }}</span>
              <span class="s2">{{ user.incomeToBeCollected }}</span>
            </p>
          </div>
          <div class="block2 type2">
            <button class="buy" type="button" @click="claimIncome">{{ $t('receiveBenefits') }}</button>
            <button class="buy" type="button" @click="jumpTo('/benefit')">{{ $t('benefitList') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="alertmodel" v-show="showBuyDialog">
      <div class="shadow" @click="showBuyDialog=false"></div>
      <div class="center">
        <div class="close" @click="showBuyDialog=false"></div>
        <div class="textwords">
          <input type="number" min="100" step="100" v-model="amount" class="words">
          <div class="title">{{ $t('minimumInvestmentAmount') }}</div>
          <img src="images/cir.png" alt="">
        </div>
        <a href="javascript:" class="buy" @click="BuyPower" v-loading="isMintLoading">{{ $t('buy') }}</a>
        <div class="dec">* {{ $t('investToGetTierRewards') }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>